var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('modals-container',{staticClass:"ios-safari-modal-container"}),_c('router-view',{key:"partners",attrs:{"name":"partners"}}),_c('router-view',{key:"voucher",attrs:{"name":"voucher"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }